// Configuração central da Linkora.
// WhatsApp e Instagram: preencher quando os canais oficiais forem definidos.
// Enquanto vazios, os botões correspondentes ficam ocultos (conforme briefing).

export const siteConfig = {
    name: "Linkora",
    email: "contatolinkora@gmail.com",
    domain: "linkorastudio.com.br",
    whatsappNumber: "5513920098294", // +55 13 92009-8294 (oficial)
    instagramUser: "linkorastudio", // @linkorastudio (oficial)
};

const WHATSAPP_MESSAGE =
    "Olá! Conheci a Linkora pelo site e gostaria de solicitar um orçamento para criação de um site.";

export const mailtoUrl = `mailto:${siteConfig.email}`;

export const whatsappUrl = siteConfig.whatsappNumber
    ? `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`
    : null;

export const instagramUrl = siteConfig.instagramUser
    ? `https://www.instagram.com/${siteConfig.instagramUser}/`
    : null;

export const navLinks = [
    { id: "inicio", label: "Início" },
    { id: "servicos", label: "Serviços" },
    { id: "portfolio", label: "Portfólio" },
    { id: "sobre", label: "Sobre nós" },
    { id: "contato", label: "Contato" },
];
